// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"298":"e248380c","609":"83c183ce"}[chunkId] + ".css";
};